/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import { Track }         from './track';

/**
 *
 * @class TSOLink
 *
 * @brief companion for TSO object; each slow order spans some number of links (Track objects) in the
 * scenario.  Each one is that is included, is one of these objects.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class TSOLink {

  /** the id for the parent TSO (tso_id) */
  public             _tsoId: number     = -1;

  /** the id for the contained track (link_id) */
  public            _linkId: number     = 0;

  /** the east mileage that is in scope (east_mp) */
  public          _eastMile: number     = 0;

  /** the west mileage that is in scope (west_mp) */
  public          _westMile: number     = 0;

  /** the actual track in scope */
  public             _track: Track|null = null;

  /** @var the zero based index for this item */
  public              _nth: number      = -1;

  /** @brief standard constructor */
  constructor(      tsoId: number,
                   linkId: number,
                 eastMile: number,
                 westMile: number,
                    track: Track|null,
                      nth: number) {

    this._tsoId    = tsoId;
    this._linkId   = linkId;
    this._eastMile = eastMile;
    this._westMile = westMile;
    this._track    = track;
    this._nth      = nth;
  }

  /** create a new separate clone */
  public dup(): TSOLink {

    return new TSOLink(
      this._tsoId,
      this._linkId,
      this._eastMile,
      this._westMile,
      this._track,
      this._nth
    );
  }
}
